import moment from 'moment';

export const MAX_AGE = { amount: 2, unit: 'years' };
export const MAX_AGE_LABEL = '2 years';

export const getMinServiceDate = () => moment.utc()
  .startOf('day')
  .subtract(MAX_AGE.amount, MAX_AGE.unit);

export const getMaxServiceDate = () => moment.utc().startOf('day');
